export default function RemoveButton() {
    return (
        <i  className="icon remove_row_icon" />
    )
}